import { Component } from '@angular/core';
import { ContactUsComponent } from '@finders/finder';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'finders-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  isiOpen = false;
  hideFixedIsi = false;

  constructor(private dialog: MatDialog) {}

  openISI() {
    this.isiOpen = true;
  }

  closeISI() {
    this.isiOpen = false;
  }

  public openContactDialog() {
    this.dialog.open(ContactUsComponent, { maxWidth: '420px' });
  }

  public onInViewportChange($event) {
    this.hideFixedIsi = $event;
  }
}
